import { render, staticRenderFns } from "./modal_lesson.vue?vue&type=template&id=ab4d0808&scoped=true&"
import script from "./modal_lesson.vue?vue&type=script&lang=js&"
export * from "./modal_lesson.vue?vue&type=script&lang=js&"
import style0 from "./modal_lesson.vue?vue&type=style&index=0&id=ab4d0808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4d0808",
  null
  
)

export default component.exports